<template>
    <header class="main_menu">
        <div class="container">
            
            <div class="row align-items-center">
                <div class="col-lg-12">
                <nav class="navbar navbar-expand-lg navbar-light">
                        <a class="navbar-brand" :href="'#/'+restaurant_id+'/'+table_id"> <i style="background: #f7f7f7; padding: 4px 5px; border-radius: 5px; box-shadow: 2px 2px #d1cfcf; font-size: 12px;" class="fas fa-chevron-left"></i> </a>
						<a class="navbar-brand mr-auto" :href="'#/menu/'+restaurant_id+'/'+table_id"> <img :src="this.logo" style="object-fit: contain; max-height: 42px; border-radius: 50%;" @error="ResimageLoadError" alt="logo"> </a>
						<ul style="margin-bottom: 0;padding-left:0;">
                        <li>
                        <i class="fas fa-globe  dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="font-size: 16px;
    margin-right: 20px;  padding-top: 5px;"></i>
                            <div class="dropdown-menu bgs" style="box-shadow: 2px 2px 7px #a7a7a7; left:auto; right:0;">
                            <a @click="handleChange('en-us')" :style="{color: eng_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="en"> <flag iso="us" /> English</a>
                            <!-- <a @click="handleChange('th')" :style="{color: thai_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="th" /> ไทย </a>
                            <a @click="handleChange('ja')" :style="{color: jap_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="jp" /> 日本 </a>
                            <a @click="handleChange('ko')" :style="{color: ko_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="kp" /> 韓国語 </a>
                            <a @click="handleChange('it')" :style="{color: it_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="it" /> italiano</a>
                            <a @click="handleChange('zh-hans')" :style="{color: ch_lang ? 'red' : '#000000'}" class="dropdown-item" data-value="th"> <flag iso="cn" /> 简体中文</a> -->
                            <template v-for="lang in this.lang_list" :key="lang.id">
                                <a
                                @click="handleChange(lang.language)"
                                :style="{ color: lang_select == lang.language ? 'red' : '#000000' }"
                                class="dropdown-item"
                                data-value="th"
                            >
                            <template v-if="lang.language == 'uk'"> <flag iso="ua" /> {{lang.country}} </template> <template v-else> <flag :iso="lang.language" /> {{lang.country}} </template>
                            </a>
                            </template>
                            </div> 
                        </li>
                        </ul>
						<a style="margin-right: 1px;" class="navbar-brand" v-on:click="refreshpage()"><i class="fas fa-redo-alt" style="font-size: 16px;"></i></a>
						<ul style="margin-bottom: 0;padding-left:0;">
						<li>
							<!-- <i style="margin-left: 13px;" class="fas fa-ellipsis-v dropdown-toggle-split"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i> -->
                          <a :href="'#/order/history/'+session_id" class="dropdown-item" style="padding: 0.25rem 0rem 0.25rem 1rem;background-color: #fff;"><i class="fas fa-shopping-cart"></i></a>
							<!-- <div class="dropdown-menu bgs" style="box-shadow: 2px 2px 7px #a7a7a7; left:auto; right:0;">
								<a class="dropdown-item" v-on:click="addHelp();"> <i class="fas fa-concierge-bell"> {{ $t("message.help", {}, { locale: lang }) }} </i></a>
								<a :href="'#/restaurant/order/history/'+session_id" class="dropdown-item"><i class="fas fa-clipboard-list">  {{ $t("message.orderstatus", {}, { locale: lang }) }}</i></a>
							</div>	 -->
						</li>		
						</ul>

                        
                </nav>
                </div>
                
            </div>
        </div>
    </header>
	<section class="blog_item_section">
        <div class="container">
		<div class="row">
                <div class="col">
                    <img src="@/./assets/website/img/preparing-food.gif" style="display: block; margin-left: auto; margin-right: auto;">
                    <br/>
					<p class="text-center" style="font-size:17px; font-weight:700; color:#000;margin-bottom: 0px;">{{ $t("message.goodfood", {}, { locale: lang }) }}</p>
					<p class="text-center" style="margin-bottom: 18px;line-height: 19px;">{{ $t("message.emptycart", {}, { locale: lang }) }}</p>
				</div> 
            </div>
			<div class="row">
				<div class="col-md-12 text-center">
					<a :href="'#/menu/'+restaurant_id+'/'+table_id" class="genric-btn primary circle mb-3" style="font-size:15px;box-shadow: 2px 2px 7px #a7a7a7;">
					{{ $t("message.browsemenu", {}, { locale: lang }) }}</a>
				</div>
			</div>
		</div>
    </section>
</template>

<script>
export default {
    data: function() {
       return{
        session_id:null,
        restaurant_id:null,
        table_id:null,
        currency:null,
        lang: "",
        eng_lang: false,
        thai_lang: false,
        jap_lang: false,
        ko_lang: false,
        it_lang: false,
        ch_lang: false,
        ru_lang: false,
        uk_lang: false,
        lang1: false,
        lang2: false,
        lang_list: [],
        lang_select: ''
       }
        
    },

    methods:{
        handleChange: function(a){
            localStorage.setItem('lang', a);
            this.lang = a;

            if (a === 'en-us') {
                this.eng_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = ''
            }
            else if (a === 'th'){
                // this.thai_lang = true;
                // this.eng_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ko'){
                // this.ko_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.eng_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
                
            }
            else if (a === 'ja'){
                // this.jap_lang = true;
                // this.thai_lang = false;
                // this.eng_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'it'){
                // this.it_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'zh-hans'){
                // this.ch_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ro'){
                // this.ro_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ru_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'ru'){
                // this.ru_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.uk_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
            }
            else if (a === 'uk'){
                // this.uk_lang = true;
                // this.thai_lang = false;
                // this.jap_lang = false;
                // this.ko_lang = false;
                // this.it_lang = false;
                // this.eng_lang = false;
                // this.ch_lang = false;
                // this.ro_lang = false;
                // this.ru_lang = false;
                this.lang_select = a;
                this.eng_lang = false;
                
            }
            
        },
        ResimageLoadError: function(event){
            event.target.src = require("@/assets/website/img/logo.png");
        },
        refreshpage: function(){

            window.location.reload();
        },
    },

    mounted: function(){

        if(!localStorage.getItem('session_id')){
          this.$router.push('/pagenotfound/');
      }
    var session_id = localStorage.getItem('session_id');
    var restaurant_id = localStorage.getItem('restaurant_id');
    var table_id = localStorage.getItem('table_id');
    var currency = localStorage.getItem('currency');
    var lang = localStorage.getItem('lang');
    this.restaurant_id = restaurant_id;
    this.table_id = table_id;
    this.session_id = session_id;
    this.currency =  currency;
    this.lang = lang;
    this.logo = localStorage.getItem('logo');

    if (this.lang === 'en-us') {
        this.eng_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = '';
    }
    else if (this.lang  === 'th'){
        // this.thai_lang = true;
        // this.eng_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'th';
        this.eng_lang = false;
    }
    else if (this.lang  === 'ko'){
        // this.ko_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.eng_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ko';
        this.eng_lang = false;
    }
    else if (this.lang  === 'ja'){
        // this.jap_lang = true;
        // this.thai_lang = false;
        // this.eng_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ja';
        this.eng_lang = false;
    }
    else if (this.lang  === 'it'){
        // this.it_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'it';
        this.eng_lang = false;
    }
    else if (this.lang  === 'zh-hans'){
        // this.ch_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'zh-hans';
        this.eng_lang = false;
    }
    else if (this.lang === 'ro'){
        // this.ro_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ru_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ro';
        this.eng_lang = false;
    }
    else if (this.lang === 'ru'){
        // this.ru_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.uk_lang = false;
        this.lang_select = 'ru';
        this.eng_lang = false;
    }
    else if (this.lang === 'uk'){
        // this.uk_lang = true;
        // this.thai_lang = false;
        // this.jap_lang = false;
        // this.ko_lang = false;
        // this.it_lang = false;
        // this.eng_lang = false;
        // this.ch_lang = false;
        // this.ro_lang = false;
        // this.ru_lang = false;
        this.lang_select = 'uk';
        this.eng_lang = false;
    }

    var config5 = {
      method: "get",
      url:process.env.VUE_APP_BASE_URI +
        "/api/userapi/language/list/" +
        this.restaurant_id +
        "/",
      headers: {},
    };
    this.axios(config5).then((response) => {
      if (response.status) {

          this.lang_list = response.data.data;
          
      }
    });

    let _this = this;
    window.onhashchange = function() {
        
            var order_detail_url = window.location.hash;
            if (order_detail_url.includes('order_detail')){
                console.log("in order detail");
                
                this.localStorage.setItem('menureload',1);
                window.location.href= '#/menu/'+_this.restaurant_id+'/'+_this.table_id;
            }
            else{
                console.log("not order detail");
            }
            }

    }
}
</script>